export const CRUD_PATH = `dayStreetPart`

export const CRUD_PATH_PLURAL = `dayStreetParts`